import React from 'react';
import MediaQuery from 'react-responsive';
import { RequestsInfo } from './RequestsInfo';
import { useKeycloak } from '@nic-react/auth';
import DashboardCalendar from './DashboardCalendar';


export const Dashboard = () => {

    const {keycloak} = useKeycloak()

    if (keycloak.realm === 'registry') {
        return (
            <div
                style={{display: 'flex', flexDirection: 'column'}}
            >
                <MediaQuery minWidth={1224}>
                    <div style={{display: 'flex', width: '100%'}}>
                        <RequestsInfo type={'registrar'}/>
                        <RequestsInfo type={'dnssec'}/>
                    </div>
                </MediaQuery>

                <MediaQuery minWidth={850} maxWidth={1224}>
                    <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                        <RequestsInfo type={'registrar'}/>
                        <RequestsInfo type={'dnssec'}/>
                    </div>
                </MediaQuery>

                <MediaQuery minWidth={300} maxWidth={849}>
                    <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                        <RequestsInfo type={'registrar'}/>
                        <RequestsInfo type={'dnssec'}/>
                    </div>
                </MediaQuery>
                <DashboardCalendar period={'week'}/>
            </div>
        )
    } else {
        return (<span>Registrar</span>)
    }
}